// eslint-disable-next-line no-shadow
export enum MediaType {
	Photography = `Photography`,
	GraphicDesign = `Graphic Design`,
	Animation = `Animation`,
	Illustration = `Illustration`,
	UiDesign = `UI Design`
}